<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate />
    </div>
    <div v-else>
      <div v-if="isArtist" class="text-xs-right">
        <tk-btn
          v-if="account.evaluationStatus != 'approved'"
          :disabled="!account.isEvaluable"
          :loading="evaluationLoading"
          color="primary"
          class="text-none"
          @click="confirmEvaluate"
        >
          <span v-if="account.evaluationStatus === 'pending'"
            >{{ $t("ACCOUNT.UNDER_EVALUATION") }}...</span
          >
          <span v-else>{{ $t("ACCOUNT.EVALUATE_PROFILE") }}</span>
        </tk-btn>

        <v-tooltip dark bottom max-width="300px">
          <template v-slot:activator="{ on }">
            <v-icon size="20" color="primary" v-on="on"
              >fas fa-info-circle</v-icon
            >
          </template>
          <span>{{ $t("TOOLTIP.SEND_EVALUATION") }}</span>
        </v-tooltip>
      </div>

      <h1>{{ $t("ACCOUNT.PERSONAL_INFO") }}</h1>

      <div class="my-4" v-if="account.evaluationStatus === 'approved'">
        <h3>{{ $t("ACCOUNT.CUSTOM_URL") }}</h3>
        <a :href="account.url" target="_blank">{{ account.url }}</a>
      </div>

      <template v-if="isArtist">
        <profile-away class="my-3" :absence="account.absence" />
        <v-divider />

        <div class="text-xs-right mt-3">
          <tk-btn
            :loading="saving"
            type="button"
            color="primary"
            @click="save"
            >{{ $t("ACCOUNT.UPDATE_ACCOUNT") }}</tk-btn
          >
        </div>

        <about :account="account" />
        <v-divider />
        <cv-form :account="account" :errors="errors" />
      </template>

      <personal
        class="mt-4"
        :isArtist="isArtist"
        :account="account"
        :errors="errors"
      />

      <v-checkbox
        v-model="account.is_newsletter_subscribed"
        :label="$t('COMMON.NEWSLETTER_SUBSCRIBE')"
        color="primary"
        hide-details
      />

      <div class="text-xs-right">
        <tk-btn :loading="saving" type="button" color="primary" @click="save">{{
          $t("ACCOUNT.UPDATE_ACCOUNT")
        }}</tk-btn>
      </div>
    </div>
  </div>
</template>

<script>
import CvForm from "./CvForm.vue";
import ProfileAway from "./ProfileAway.vue";
import Personal from "./Personal.vue";
import About from "./About.vue";
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const usersRepo = RepositoryFactory.users();
const handler = new ErrorHandler();

export default {
  components: {
    CvForm,
    ProfileAway,
    Personal,
    About,
  },

  data() {
    return {
      loading: false,
      saving: false,
      evaluationLoading: false,
      account: {},
      errors: {},
    };
  },

  computed: {
    isArtist() {
      if (this.$auth.currentUser) {
        return this.$auth.currentUser.isArtist;
      }
      return false;
    },
  },

  created() {
    this.fetchData();
    this.$auth.refresh();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      await handler.handle(async () => {
        this.account = await usersRepo.account();
        console.log(this.account);
      });
      this.loading = false;
    },

    async confirmEvaluate() {
      const confirm = await this.$root.$confirm(
        this.$t("ACCOUNT.EVALUATE_PROFILE"),
        this.$t("ACCOUNT.EVALUATE_DESC"),
        {
          width: "500px",
        }
      );

      console.log("Confirm", confirm);
      if (confirm) {
        this.evaluationLoading = true;
        await handler.handle(async () => {
          await usersRepo.evaluate();
          this.account.evaluationStatus = "pending";
          this.account.isEvaluable = false;
        });
        this.evaluationLoading = false;
      }
    },

    async save() {
      console.log("Save account", this.account);
      this.errors = {};
      this.saving = true;

      try {
        const res = await usersRepo.updateAccount(
          this.$auth.currentUser.id,
          this.account
        );
        console.log(res);
        this.$app.toast(this.$t("ACCOUNT.UPDATE_SUCCESS"));
      } catch (error) {
        if (error.status === 422 && error.data) {
          this.errors = error.data.errors;
          console.log(this.errors);
        }
      }

      this.saving = false;
    },
  },
};
</script>



